import { TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var Loteo_constComponent = /** @class */ (function () {
    function Loteo_constComponent(dialog) {
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            const_simultanea: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("loteo_const"))) {
            localStorage.setItem("loteo_const", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("loteo_const"));
            this.form.controls['const_simultanea'].setValue(this.rows[0] ? this.rows[0].const_simultanea : '');
        }
        this.loteo_const = { const_simultanea: '' };
    }
    Loteo_constComponent.prototype.add_loteo_const = function () {
        localStorage.setItem("loteo_const", JSON.stringify([]));
        this.actualRow = localStorage.getItem("loteo_const");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            const_simultanea: this.form.value.const_simultanea
        });
        localStorage.setItem("loteo_const", JSON.stringify(this.rows));
        this.actualRow2 = localStorage.getItem("loteo_const");
        console.log(this.actualRow2);
        this.form.reset(); //
    };
    Loteo_constComponent.prototype.cleanData = function () {
        this.temp_carct_loteo = { const_simultanea: "" };
    };
    Loteo_constComponent.prototype.delete_loteo_const = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("loteo_const", JSON.stringify(this.rows));
            }
        }
    };
    return Loteo_constComponent;
}());
export { Loteo_constComponent };
